/**
 * AR content for the "Nice – Monaco" private excursion.
 *
 * Role: Arabic (MSA) translation of the FR fiche (slugs/nice-monaco.ts), typed
 * `ExcursionPage` so the shared ExcursionSlugView renders it identically.
 * Dependencies: slug-excursions (type), destination image asset.
 * The slug stays a proper-noun place name → mirrored from FR ("nice-monaco").
 */
import type { ExcursionPage } from "../slug-excursions";
import monaco from "@/assets/images/excursions/destinations/monaco.webp";

const page: ExcursionPage = {
  slug: "nice-monaco",
  hero: {
    title: "رحلة نيس – موناكو",
    subtitle: "اكتشف الريفييرا الفرنسية بين نيس وإمارة موناكو برفقة سائق خاص.",
    ctaPrimaryHref: "/reservation",
    ctaPrimaryLabel: "احجز الآن",
    ctaSecondaryHref: "/contact",
    ctaSecondaryLabel: "اطلب عرض سعر",
    image: monaco,
  },
  generic: {
    heading: "بانوراما متوسطية",
    paragraphs: [
      "انطلق من كان لاستكشاف نيس وممشى الإنجليز، ثم توجّه إلى موناكو وصخرتها الشهيرة.",
    ],
  },
  highlights: {
    title: "أبرز المعالم",
    items: [
      {
        text: "ممشى الإنجليز وتلة القلعة والبلدة القديمة في نيس",
      },
      { text: "إمارة موناكو: الصخرة والكازينو والحدائق وميناء هرقل" },
      {
        text: "طرق ساحلية بانورامية ووقفات للتصوير واقتراحات لمحبي المأكولات",
      },
      { text: "انطلاق وعودة مرنان من كان وضواحيها" },
    ],
  },
  itinerary: {
    title: "برنامج مقترح",
    steps: [
      {
        title: "الانطلاق من كان",
        description: "الاصطحاب من العنوان الذي تختاره.",
      },
      {
        title: "نيس",
        description: "ممشى الإنجليز والبلدة القديمة والسوق (حسب اليوم).",
      },
      {
        title: "موناكو",
        description: "الصخرة والكازينو والميناء ووقت حر.",
      },
      {
        title: "العودة إلى كان",
        description: "رحلة مريحة وفي الموعد المحدد.",
      },
    ],
  },
  practical: {
    title: "معلومات عملية",
    items: [
      {
        label: "المدة",
        value: "من 4 إلى 8 ساعات حسب رغبتك (المقترح: 6 ساعات)",
      },
      { label: "الانطلاق", value: "كان وضواحيها" },
      {
        label: "يشمل",
        value: "سائق خاص، ماء، واي فاي، مسار مخصّص",
      },
      {
        label: "خيار",
        value: "وقت حر للتسوّق / المتحف حسب أوقات الفتح",
      },
    ],
  },
};

export default page;
